import { useQuery } from "@tanstack/react-query";
import { getSevenRoomsMappings } from "../../api/bSevenroomsApi";

export const useGetSevenRoomsMappings = (organisationId) => {
  return useQuery({
    queryKey: ["sevenrooms-mappings", organisationId],
    queryFn: () => getSevenRoomsMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    onError: (error) => {
      console.error("Error fetching SevenRooms mappings:", error.response || error);
    },
  });
};
